import { render, staticRenderFns } from "./include_proposal_situation.vue?vue&type=template&id=10f7965e&scoped=true&"
import script from "./include_proposal_situation.vue?vue&type=script&lang=js&"
export * from "./include_proposal_situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7965e",
  null
  
)

export default component.exports